module.exports = __webpack_public_path__ + "static/img/test-site-img.ba4d7c96.png";